/*=========================================================================================
  File Name: moduleDeviceMutations.js
  Description: Device Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    SET_DEVICE(state, data) {
        state.deviceList = data.resultBody
        state.count = data.resultCount
    },
    SET_DEVICE_STATUS(state, data) {
        for (let index in data.resultBody) {
            data.resultBody[index].value = Number(data.resultBody[index].value)
        }
        state.deviceStatus = data.resultBody
    },
    SET_USED_SUBSCRIBE(state, data) {
        state.usedSubscribe = data.resultBody
    }

}